import React from 'react';
import {blogsAPI} from "../api/api";
import ShowNotification from "../components/common/Notification/ShowNotification";

const SET_BLOG_DATA = 'SET_BLOG_DATA';
export const setBlogData = (payload) => {
    return {
        type: SET_BLOG_DATA,
        payload: payload
    }
}

let initialState = {
    blogs:[
        // {
            // "id": 1,
            // "title": "title 3",
            // "content": "content 3",
            // "imgUrl": "100",
            // "youtubeLink": "1010",
            // "status": 1,
            // // "startDate": "2021-06-28 14:00:00",
            // // "endDate": "2021-08-28 18:00:00",
            // "created_at": "2021-07-21T15:48:51.000000Z",
            // "updated_at": "2021-07-21T15:48:51.000000Z"
        // }
    ],
    totalPages:4,
    totalElements:31,
    size:10
}

let blogReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_BLOG_DATA:
            return {
                ...state,
                blogs:action.payload.blogs,
                totalPages: action.payload.totalPages,
                totalElements: action.payload.totalElements,
                size: action.payload.size,
            }

        default :
            return state;
    }
}


export const getBlogsTh = (page,size) => {
    return async (dispatch) => {
        let response = await blogsAPI.getBlogs(page,size );
        debugger
        if (response) {
            dispatch(setBlogData(response));
        }else {
            let errorMessage='Server: '+response.response.data;
            ShowNotification("Error",errorMessage,"danger",3000)
        }
    }
}
export const addBlogTh = (product) => {
    return async (dispatch) => {
        let response = await blogsAPI.addBlog(product);
        debugger
        if (response.status===201) {
            debugger
            ShowNotification("Succes","Blog added successful", "success")
            dispatch(getBlogsTh(0,10));
        } else {
            let errorMessage='Server: '+response.response.data;
            ShowNotification("Error",errorMessage,"danger",3000)
        }
    }
}
export const updateBlogTh = (product) => {
    return async (dispatch) => {
        debugger
        let response = await blogsAPI.editBlog(product);
        if (response.status === 200) {
            ShowNotification("Succes","Blog updated successful", "warning")
            dispatch(getBlogsTh(0,10));
        } else {
            let errorMessage='Server: '+response.data.message;
            ShowNotification("Error",errorMessage,"danger",3000)
        }
    }
}
export const deleteBlogTh = (productId) => {
    return async (dispatch) => {
        debugger
        let response = await blogsAPI.deleteBlog(productId );
        if (response.status === 200) {
            // dispatch(deleteBuildingData(response.content));
            ShowNotification("Succes","Blog deleted successful", "danger")

            dispatch(getBlogsTh(0,10));
        }else {
            let errorMessage='Server: '+response.data.message ;
            ShowNotification("Error",errorMessage,"danger",3000)
        }
    }
}
export default blogReducer;
